import React, { useEffect } from "react";
import { Container } from "@mui/material";
import UsersList from "../../components/users/UsersList";
import NewLayout from "../../layout/dashboard/NewLayout";
import { useRole } from "../../hooks/useRole";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const role = useRole()
  const navigate = useNavigate()
  useEffect(() => {
    if (role && role !== 'org-admin') {
      navigate("/dashboard")
    }
  }, [])
  return (
    <NewLayout>
      <Container maxWidth="xxl">
        <UsersList />
      </Container>
    </NewLayout>
  );
};

export default Users;
